import { ActionType } from './action-type';

export const actionTypeArray = [
    ActionType.RECORD_START,
    ActionType.RECORD_STOP,
    ActionType.RECORD_SERVE,
    ActionType.RECORD_CLEAR,
];
